import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import { getRandomInt, randomString, getCDate, check, sleep, genKey } from '@/customFunction';
import { firebase, db, auth } from '@/fb'
import { productApiUrl, yervipUrl } from '@/config/urls';
const headers = {'Accept': 'application/json'};

Vue.use(Vuex)

const publicStorageBaseUrl = () => {
  const env = process.env.VUE_APP_PUBLIC_STORAGE_BASE_URL
  if (env) return env.replace(/\/+$/, '') + '/'
  // Backwards-compatible fallback (production historically used /back)
  return `${yervipUrl('back/storage/app')}/`
}

export default new Vuex.Store({
  state: {
    menu: {
      user: [
        { icon: 'dashboard', text: 'Dashboard', path:'/' },
        { icon: 'dashboard', text: 'CRM', path:'/crm' },
        { icon: 'menu_open', text: 'Q', path:'/Q' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Whatsapp',
          model: false,
          children: [
            { icon: 'send', text: 'Whatsapp New Chat', path:'/wa-new-chat' },
            //{ icon: 'people', text: 'Bulk Whatsapp', path:'/data' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Vouchers',
          model: false,
          children: [
            { icon: 'receipt', text: 'Vouchers', path:'/vouchers' },
          ]
        },
      ],
      admin:[
        { icon: 'dashboard', text: 'Dashboard', path:'/' },
        { icon: 'dashboard', text: 'Scanner App', path:'/scanner' },
        { icon: 'dashboard', text: 'CRM', path:'/crm' },
        { icon: 'menu_open', text: 'Q', path:'/Q' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Admin',
          model: false,
          children: [
            { icon: 'analytics', text: 'Stats', path:'/stats' },
            { icon: 'settings', text: 'Settings', path:'/user-settings' },
            { icon: 'account_balance', text: 'Invoice settings', path:'/invoice-settings' },
            { icon: 'view_list', text: 'Campaigns', path:'/campaigns' },
            { icon: 'view_list', text: 'Clearance Ashyaat', path:'/clearance-site' },
            { icon: 'near_me', text: 'Manual Migrate', path:'/migrate' },
            { icon: 'money', text: 'Payment Update', path:'/payments' },
            { icon: 'payments', text: 'Issue Influencer Invoice', path:'/issue-invoice' },
            { icon: 'view_list', text: 'Influencer Invoices', path:'/inf-invoices' },
            { icon: 'close', text: 'Delete By Key', path:'/delete-by-key' },
            { icon: 'close', text: 'Reverse Status By Key', path:'/reverse-by-key' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Warehouse',
          model: false,
          children: [
            { icon: 'apps', text: 'Products Catalogue', path:'/products-catalogue' },
            { icon: 'graphic_eq', text: 'Warehouseh Integration', path:'/warehouse-integration' },
            { icon: 'local_shipping', text: 'Warehouse', path:'/warehouse' },
            { icon: 'smartphone', text: 'Warehouse App', path:'/warehouse-app' },
            { icon: 'view_list', text: 'Warehouse Log', path:'/warehouse-log' },
            { icon: 'local_airport', text: 'Shipping Update', path:'/shipping' },
            { icon: 'all_inbox', text: 'Price History', path:'/price-history' },
            { icon: 'all_inbox', text: 'Purchase Orders', path:'/purchase-orders' },
            { icon: 'all_inbox', text: 'Move Orders', path:'/move-orders' },
            { icon: 'all_inbox', text: 'Hurt Orders', path:'/hurt-orders' },
            { icon: 'paid', text: 'Invoicing', path:'/Invoicing' },
            { icon: 'ondemand_video', text: 'Live Warehouse', path:'/warehouse-live' },
            { icon: 'local_shipping', text: 'Reservation Settings', path:'/reservation-settings' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Call Center',
          model: false,
          children: [
            { icon: 'settings_phone', text: 'Call Center Setup', path:'/call-center-setup' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Website',
          model: false,
          children: [
            { icon: 'apps', text: 'Products', path:'/products' },
            { icon: 'list_alt', text: 'Bulk Vendor Pricing', path:'/bulk-vendor' },
            { icon: 'list_alt', text: 'Bulk Remaining Import', path:'/bulk-remaining' },
            { icon: 'aspect_ratio', text: 'Landing Pages', path:'/landing-pages' },
            { icon: 'view_list', text: 'Static Pages', path:'/static-pages' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Vouchers',
          model: false,
          children: [
            { icon: 'receipt', text: 'Vouchers', path:'/vouchers' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Imports',
          model: false,
          children: [
            { icon: 'cloud_upload', text: 'Import Orders', path:'/import-orders' },
            { icon: 'cloud_upload', text: 'Import Products', path:'/import-products' },
            { icon: 'cloud_upload', text: 'Import Cities', path:'/import-cities' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Forms',
          model: false,
          children: [
            { icon: 'aspect_ratio', text: 'Form Builder', path:'/form-builder' },
            { icon: 'aspect_ratio', text: 'Forms', path:'/form-embeds/1' },
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Whatsapp',
          model: false,
          children: [
            { icon: 'send', text: 'Whatsapp New Chat', path:'/wa-new-chat' },
            { icon: 'send', text: 'Manual Bulk WA', path:'/manual-wa' },
            { icon: 'cloud_upload', text: 'Whatsapp Settings', path:'/wa-settings' },
            { icon: 'cloud_upload', text: 'Import Data', path:'/import-data' },
            { icon: 'people', text: 'Bulk Whatsapp Data', path:'/data' },
            { icon: 'people', text: 'Whatsapp Campaigns', path:'/wa-campaigns' },
          ]
        },
        
      ],
      app:[
        { icon: 'dashboard', text: 'Scanner', path:'/scanner' },
        { icon: 'view_list', text: 'Warehouse', path:'/warehouse-app' },

      ],
      influencer:[
        { icon: 'dashboard', text: 'Dashboard', path:'/' },
        { icon: 'dashboard', text: 'CRM', path:'/inf-crm?orders=all' },
        { icon: 'money', text: 'Financials', path:'/billings' },
      ]
    },
    inf:null,
    role:null,
    user:null,
    inf_orders:[],
    inf_selected_date:null,
    productsLite:[],
    centerData:null,
    userData:null,
    tokens:null,
    leadViewShow: false,
    leadViewKey: null,
    access_token: null,
    settings: {
      baseUrl: yervipUrl(),
      apiBase: productApiUrl(),
      public: publicStorageBaseUrl(),
    },
  },
  getters: {
    
  },
  mutations: {
    openDialog(state) {
      state.leadViewShow = true
    },
    closeDialog(state) {
      state.leadViewShow = false
    },
    setBaseUrl(state, payload) {
      state.settings.baseUrl = yervipUrl()
      state.settings.apiBase = productApiUrl()
      state.settings.public = publicStorageBaseUrl()
    },
  },
  actions: {
    postResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.post(`${state.settings.apiBase}${payload.resource}`, {...payload.value})
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
    getResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.get(`${state.settings.apiBase}${payload.resource}${payload.page?payload.page:''}`)
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
    searchResource ({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.post(`${state.settings.apiBase}${payload.resource}${payload.page?payload.page:''}`, {value:payload.value})
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
    putResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.put(`${state.settings.apiBase}${payload.resource}`, {...payload.value})
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
    deleteResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        let a = await axios.delete(`${state.settings.apiBase}${payload.resource}`)
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
    loadAllResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`
        axios.interceptors.request.use(function (config) {
          let token = state.access_token
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
          }
          return config;
        }, function (error) {
          return Promise.reject(error);
        })
        axios.interceptors.response.use(async response => {
          return response;
        }, async error => {
          if (error.response.status === 401) {
            await dispatch('goOffline')
            commit('unAuthLogout')
          }
          return error;
        });
        console.log(`${state.settings.apiBase}${payload.resource}-all`)
        let a = await axios.get(`${state.settings.apiBase}${payload.resource}-all`)
          .then(x => x.data).catch(error=>{})
          console.log(a)
          resolve(a)
      })
    },
  },
})